import { useMutation } from '@tanstack/react-query'
import { getThumbnail } from '../../service/list'

function useGetThumbnailByPlacid() {
  return useMutation({
    mutationKey: ['get-thumbnail-placid'],
    mutationFn: getThumbnail,
  })
}

export default useGetThumbnailByPlacid
